import React from 'react';

import styled from 'styled-components';
import searchIcon from '../../../asset/img/common/search_icon.svg';
import { useTranslation } from 'react-i18next';

const AddressInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 5px;
  border: 1px solid var(--GrayScale-400);
  background: var(--GrayScale-0);
  height: 50px;

  input {
    width: 100%;
    border: none;
    outline: none;
  }

  input::placeholder {
    color: var(--GrayScale-500);
  }
`;

const AddressInput = ({ activeTab, addressInput, setAddressInput }) => {
  const { t } = useTranslation('myInfo');
  let placeholder =
    activeTab == 0
      ? t('address.placeholder')
      : activeTab == 1
      ? '예) 여의도동 14'
      : '주소를 직접 입력해주세요';

  return (
    <AddressInputWrapper>
      {activeTab != 2 ? <img src={searchIcon} alt="search" /> : null}
      <input
        // style={{ height: '50px' }}
        placeholder={placeholder}
        value={addressInput}
        onChange={e => setAddressInput(e.target.value)}
      />
    </AddressInputWrapper>
  );
};

export default AddressInput;
